import React, { Component } from 'react';
import $ from 'jquery';
import PropTypes from 'prop-types';

class LoginController extends Component {
    loggedIn = false;

    constructor(props) {
        super(props);
        const self = this;
        this.refreshState = props.refreshState;
        window.loginController = this;

        $.ajax({ 
          type: "GET",
          url: "https://db.marbleer.com/user/me",
          xhrFields: {
               withCredentials: true
          },
          crossDomain: true,
          success: function(xhr){
            self.loggedIn = true;
            self.loginCache = xhr;
          },
          error: function () {
            self.loggedIn = false;
          }
        }).always(self.refreshState);
    }

    login() {
        window.location.href = "https://db.marbleer.com/user/login";
    }

    logout() {
        const self = window.loginController;
        $.ajax({ 
          type: "GET",
          url: "https://db.marbleer.com/user/logout",
          xhrFields: {
               withCredentials: true
          },
          crossDomain: true,
          success: function(xhr){
            self.loggedIn = false;
            self.loginCache = {};
          },
          error: function () {
            console.log("Error logging out");
          }
        }).always(self.refreshState());
    }

    render() {
        return <b></b>
    }
}

LoginController.propTypes = {
    refreshState: PropTypes.func.isRequired
};

export default LoginController; // Don’t forget to use export default!


// WEBPACK FOOTER //
// ./src/LoginController.js